"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithStylesAttrArgs = exports.RescheduleWorkDrawerWithContext = exports.RescheduleWorkDrawerExample = exports.RescheduleWorkArgs = exports.DefaultArgs = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var providers_1 = require("../../providers");
var il_button_common_1 = require("../il-button/il-button.common");
var il_dropdown_common_1 = require("../il-dropdown/il-dropdown.common");
var il_temporary_drawer_1 = require("../il-temporary-drawer/il-temporary-drawer");
var il_student_list_1 = require("./il-student-list");
var DefaultArgs = {
    students: il_dropdown_common_1.StudentFilterImplementationArgs,
    onSelectStudent: console.log,
};
exports.DefaultArgs = DefaultArgs;
var WithStylesAttrArgs = __assign(__assign({}, DefaultArgs), { showChevrons: true, showDividers: true, selected: il_dropdown_common_1.StudentFilterImplementationArgs[0] });
exports.WithStylesAttrArgs = WithStylesAttrArgs;
var RescheduleWorkArgs = __assign(__assign({}, DefaultArgs), { showChevrons: true, showDividers: true, header: 'Reschedule Work' });
exports.RescheduleWorkArgs = RescheduleWorkArgs;
function RescheduleWorkDrawerWithContext(_a) {
    var _b = _a.clickableComponent, clickableComponent = _b === void 0 ? react_1.default.createElement(il_button_common_1.RescheduleButton, null) : _b, props = __rest(_a, ["clickableComponent"]);
    var ctx = (0, providers_1.usePlannerContext)();
    function ChildrenElement(_a) {
        var _b;
        var onClose = _a.onClose;
        return (react_1.default.createElement(material_1.Box, { sx: { p: 2 } },
            react_1.default.createElement(il_student_list_1.ILStudentList, __assign({}, props, RescheduleWorkArgs, { selected: (_b = ctx.students) === null || _b === void 0 ? void 0 : _b.find(function (student) { return student.guid === ctx.selectedStudent; }), students: ctx.students, onSelectStudent: function (student) {
                    ctx.selectStudent(student.guid);
                    onClose && onClose();
                } }))));
    }
    return (react_1.default.createElement(il_temporary_drawer_1.ILTemporaryDrawer, { showClose: true, clickableComponent: clickableComponent, sx: props.sx },
        react_1.default.createElement(ChildrenElement, null)));
}
exports.RescheduleWorkDrawerWithContext = RescheduleWorkDrawerWithContext;
function ShowSelected() {
    var ctx = (0, providers_1.usePlannerContext)();
    return react_1.default.createElement("div", { "data-testid": "selected-student" }, JSON.stringify(ctx.selectedStudent));
}
function RescheduleWorkDrawerExample(_a) {
    var studentList = _a.studentList;
    return (react_1.default.createElement(providers_1.PlannerProvider, { defaultContext: {
            students: studentList,
        } },
        react_1.default.createElement(RescheduleWorkDrawerWithContext, null),
        react_1.default.createElement(ShowSelected, null)));
}
exports.RescheduleWorkDrawerExample = RescheduleWorkDrawerExample;
